import React, {useState, useEffect} from 'react';
import logo from './img/logo.svg';
import './css/App.css';
import './css/bootstrap.min.css';
import bootstrap from 'bootstrap'
const axios = require('axios').default;

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: ""
    };
    this.handleChange = this.handleChange.bind(this);
  }

  //This just updates the state of the component when you type on the form
  handleChange(e){
    this.setState({[e.target.id]: e.target.value});
  }

  render() {
    return(
      <div className='login-popup'>
        <h1>Welcome to Dashboard</h1>
        <form onSubmit={this.props.loginButton}>
          <div className="mb-3">
            <label className="form-label">Login</label>
            <input onChange={this.handleChange} type="text" className="form-control" id="username" aria-describedby="userName"></input>
            <div id="userName" className="form-text"></div>
          </div>
          <div className="mb-3">
            <label className="form-label">Password</label>
            <input onChange={this.handleChange} type="password" className="form-control" id="password"></input>
          </div>
          <div className="mb-3">
            <p>{this.props.infoMessage}</p>
          </div>
          <button type="submit" className="btn btn-primary">Submit</button>
        </form>
      </div>
    );
  }
}
export default LoginForm;